import emptySplitApi from "../utils/rtk";
import { User, updateProfile } from "../types/User";
import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  statusCode: number;
  message: string;
  s3Location?: string;
};

type PostLoginBody = {
  email: string;
  password: string;
};
type queryUser = {
  page: number;
  search: string;
};
export const contentReport = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    contentReport: builder.query<
      CommonResponseType & { data: any },
      { status?: number; page?: number; search?: string }
    >({
      query: ({ status, page, search }) => {
        let url = END_POINTS.contentReport;
        const queryParams = [];
        if (page) {
          queryParams.push(`page=${page}`);
        }
        if (search) {
          queryParams.push(`search=${search}`);
        }
        if (status) {
          queryParams.push(`status=${status}`);
        }
        // if (limit) {
        //   queryParams.push(`limit=${limit}`);
        // }
        // if (value != undefined) queryParams.push(`supportType=${value + 1}`);
        if (queryParams.length > 0) {
          url += `?${queryParams.join("&")}`;
        }

        return {
          url: url,
          method: "GET",
        };
      },
    }),

    PostContentQuery: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.contentReport}`,
        method: "POST",
        body,
      }),
    }),

    // EditUser: builder.mutation<
    //   CommonResponseType & { data: CommonBody },
    //   { id: string | undefined; body: CommonBody }
    // >({
    //   query: ({ body, id }) => ({
    //     url: `${END_POINTS.updateParent}/${id}`,
    //     method: "PUT",
    //     body,
    //   }),
    // }),

    deleteContentSupportById: builder.query<
      CommonResponseType & { data: any },
      { userId: any }
    >({
      query: ({ userId }) => ({
        url: `${END_POINTS.contentReport}/${userId}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  usePostContentQueryMutation,
  useLazyContentReportQuery,
  useLazyDeleteContentSupportByIdQuery,
} = contentReport;
